<template>
  <div>
    <div class="payment-page">
      <div v-if="show">
        <div class="topT">
          <div>Order will be closed in:</div>
          <div class="timer">
            <van-count-down
              :style="
                time == '999999999999999'
                  ? 'color: #fff;font-size: 15px;'
                  : 'font-size: 1.3rem;'
              "
              format="mm:ss"
              :time="time"
              @finish="onFinish"
            />
          </div>
        </div>

        <div style="font-size: 16px; color: #212739; margin-bottom: 16px">
          Amount payable
        </div>

        <div class="moneyBox">
          <p>₹ {{ form.orderAmount }}</p>
        </div>

        <p
          style="
            font-size: 16px;
            padding: 16pt 0 18pt;
            border-bottom: 1px solid #f2f2f2;
          "
        >
          Select payment method
        </p>
        <div
          class="payBox"
          v-for="(item, index) in form.walletList"
          :key="index"
        >
          <div>
            <img
              v-if="item.walletCode == 'paytm'"
              class="img1"
              src="@/assets/paytm.png"
              alt=""
            />
            <img
              v-if="item.walletCode == 'phonepe'"
              class="img1"
              src="@/assets/phonePe.jpg"
              alt=""
            />

            <p>{{ item.walletCode }}</p>

            <img
              class="img2"
              src="@/assets/huo.png"
              alt=""
              v-if="item.walletCode == 'paytm'"
            />
            <p style="color: #df2626" v-if="item.walletCode == 'paytm'">
              (Instant)
            </p>
            <!-- <p
              style="
                color: #cacaca;
                font-size: 12px;
                margin-left: 6px;
                transform: translateY(4px);
              "
            >
              {{ form.randomAmount }}
            </p> -->
          </div>
          <div class="payBtn" @click="payOne(2, item.clickUrl)">PAY>></div>
        </div>
        <div class="payBox">
          <div>
            <img class="img1" src="@/assets/sao.png" alt="" />
            <p>Qrcode</p>
          </div>
          <div class="payBtn" @click="payOne(1)">PAY>></div>
        </div>

        <div class="payBox">
          <div>
            <img class="img1" src="@/assets/wenjian.png" alt="" />
            <p>Manual transfer(Copy UPI ID)</p>
          </div>
          <div class="payBtn" @click="payOne(3)">PAY>></div>
        </div>

        <div class="txtBox1">
          <p>1.Please make sure you have installed the app.</p>
          <p>2. Don't pay for the same link repeatedly.</p>
        </div>

        <div class="txtBox2">
          <p style="font-size: 16px; margin-bottom: 24pt">Notice:</p>
          <p>
            1.Please select the payment method you need and make sure your phone
            has the corresponding wallet software installed
          </p>
        </div>

        <van-action-sheet v-model="showOne" title=" ">
          <div class="content">
            <div v-if="showNum == 1">
              <p class="showOneTitle">1.Copy the below given UPI</p>

              <div class="showOneSearch">
                <van-field
                  style="
                    border: 0.5px solid #c5c3c3;
                    flex: 1;
                    height: 2.3rem;
                    line-height: 2.3rem;
                    padding: 0 14px;
                  "
                  v-model="form.upiAccountHide"
                  placeholder=""
                  disabled
                />
                <div class="showOneCopy" v-debounce="copyUpiId">COPY</div>
              </div>

              <p class="showOneTxt">
                Tip: Don't save the UPI, get new UPI every time.
              </p>

              <p class="showOneTitle">2. Need to enter your 12 Ref No(UTR)</p>
              <div class="showOneSearch" style="border: 0.5px solid #c5c3c3">
                <div class="showOneSearchLabel">
                  <P>*</P>
                  <p style="line-height: 2.3rem">UTR</p>
                </div>
                <van-field
                  style="
                    flex: 1;
                    height: 2.3rem;
                    line-height: 2.3rem;
                    padding: 0 14px;
                  "
                  v-model="utrValue"
                  placeholder="input UTR number"
                />
              </div>

              <p class="test1" @click="noFlase">How to Find Your UTR?</p>

              <p class="showOneTxt">
                Tip: Open your UPI wallet and complete the transfer Record your
                reference No.(UTR) after payment.
              </p>
            </div>

            <div v-if="showNum == 2">
              <div class="qrCodeImgs">
                <p>Use Mobile Scan code to pay</p>

                <!-- <van-image width="154pt" height="154pt" fit="fill" :src="formattedQrCode" /> -->
                <van-image
                  width="154pt"
                  height="154pt"
                  style="margin-bottom: 26px"
                  fit="fill"
                  :src="formattedQrCode"
                />
              </div>

              <div class="showOneSearch" style="border: 0.5px solid #c5c3c3">
                <div class="showOneSearchLabel">
                  <P>*</P>
                  <p style="line-height: 2.3rem">UTR</p>
                </div>
                <van-field
                  style="
                    flex: 1;
                    height: 2.3rem;
                    line-height: 2.3rem;
                    padding: 0 14px;
                  "
                  v-model="utrValue"
                  placeholder="input UTR number"
                />
              </div>
              <p class="test1" @click="noFlase">How to Find Your UTR?</p>
              <p class="showOneTxt">
                Tip: Open your UPI wallet and complete the transfer Record your
                reference No.(UTR) after payment.
              </p>
            </div>

            <div v-if="showNum == 9">
              <div>
                <p class="mSy" style="margin-bottom: 6px; color: #2a50ba">
                  ₹
                  {{ form.randomAmount }}
                </p>
                <p class="mSy mSyTwo" style="color: #2a50ba">
                  ₹ <s> {{ form.orderAmount }}</s>
                </p>
              </div>

              <p class="payTxt">Payment via Paytm, Limited-Time Offer</p>
            </div>

            <div class="btnFun" v-if="showNum == 9" @click="payOne(9)">
              TO PAY
            </div>
            <div class="btnFun" v-if="showNum != 9" v-debounce="submitPayment">
              Submit UTR
            </div>
          </div>
        </van-action-sheet>
      </div>

      <div v-else>
        <div class="sBox" v-if="status == 'wait'">
          <!-- <van-image width="100" height="100" :src="require('../assets/时间@2x.png')" />
          <p class="sp">
            The payment result is being confirmed<br/> Please wait patiently.
          </p> -->
          <div v-if="orderStatus == ''" class="sBox">
            <div class="circle">
              <div class="dots">
                <div
                  v-for="n in 8"
                  :key="n"
                  class="dot"
                  :style="getDotStyle(n)"
                ></div>
              </div>
              <div class="countdown">
                {{ countdown }}
              </div>
            </div>
            <p
              style="
                font-family: Source Sans Variable;
                font-weight: 400;
                text-align: center;
                font-size: 15px;
                color: #333333;
              "
            >
              UTR submitted successfully and <br />
              is being confirmed
            </p>
          </div>
          <div v-if="orderStatus == 1" class="sBox">
            <p
              style="
                font-family: Source Sans Variable;
                font-weight: bold;
                font-size: 24px;
                color: #70cf40;
                margin-bottom: 20px;
              "
            >
              <!-- ₹{{ form.orderAmount }} -->
            </p>
            <van-image
              width="100"
              height="100"
              :src="require('../assets/success@2x.png')"
            />
            <p class="sp">Your payment is successful!</p>
          </div>
          <div v-else class="sBox">
            <van-image
              width="100"
              height="100"
              :src="require('../assets/时间@2x.png')"
            />
            <p class="sp">
              The payment result may be delayed,<br />
              we will process it within 10 minutes
            </p>
          </div>
        </div>
      </div>
      <div class="sBox" v-if="status == 'timeout'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">Payment timed out, please try again</p>
      </div>

      <div class="sBox" v-if="status == 'prompt'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">
          Payment submission is successful, please wait patiently for the
          payment result
        </p>
      </div>

      <div class="sBox" v-if="status == 'err'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">{{ msg }}</p>
      </div>
    </div>

    <div class="dBox" v-if="dialogFlag">
      <div class="nos" @click="noFlase">X</div>
      <div>
        <p>MobiKwik</p>
        <img src="@/assets/to1.jpg" alt="" />
        <p>Freecharge</p>
        <img src="@/assets/to2.jpg" alt="" />
        <p>Gpay</p>
        <img src="@/assets/to3.jpg" alt="" />
        <p>PayTM</p>
        <img src="@/assets/to4.jpg" alt="" />
        <p>PhonePe</p>
        <img src="@/assets/to5.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  h5CashRegisterGetUpiV2,
  h5CopyUpi,
  h5PayOrderQuery,
  h5CheckOutClickV2,
  h5CheckOutUtrSubmit,
} from '@/api'
import { Button, Dialog } from 'vant'
import Vue from 'vue'
Vue.use(Button)
import { Icon } from 'vant'
Vue.use(Icon)
import { Field } from 'vant'
Vue.use(Field)
import { CountDown } from 'vant'
Vue.use(CountDown)
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
import { Toast } from 'vant'
Vue.use(Toast)
import { ActionSheet } from 'vant'
Vue.use(ActionSheet)
export default {
  data() {
    return {
      time: 999999999999999,
      status: '默认',
      upiId: '',
      headers: {
        'X-Plat-Order-Id': this.$route.query.orderId,
        'X-Sign': this.$route.query.sign, // 使用组件中的动态值
      },
      form: {},
      show: true,
      countdown: 10,
      interval: null,
      orderStatus: '',

      dialogFlag: false,
      msg: '',

      showOne: false,

      utrValue: '',

      showNum: 1,

      url: '',
    }
  },
  methods: {
    noFlase() {
      this.dialogFlag = !this.dialogFlag
    },
    getDotStyle(index) {
      const angle = index * 45 * (Math.PI / 180) // 每个点之间的角度
      const radius = 30 // 半径
      const x = Math.cos(angle) * radius
      const y = Math.sin(angle) * radius
      return {
        transform: `translate(${x}px, ${y}px)`,
        animation: `dot-animation 1.4s ease-in-out infinite ${index * 0.1}s`,
      }
    },
    startCountdown() {
      this.interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.interval)
        }
      }, 1000)
    },
    async getStatus() {
      const res = await h5PayOrderQuery(
        {
          platOrderId: this.$route.query.orderId,
        },
        {
          'X-Plat-Order-Id': this.$route.query.orderId,
          'X-Sign': this.$route.query.sign,
        }
      )

      if (res.status != 2) {
        clearInterval(this.interval)

        clearInterval(this.intervalStatus)

        this.orderStatus = res.status
      }
      if (res.status == 2 && this.countdown == 0) {
        this.orderStatus = 8
      }
    },
    async getInfo() {
      const res = await h5CashRegisterGetUpiV2(
        {
          platOrderId: this.$route.query.orderId,
        },
        this.headers
      )

      if (res.status == "640") {
        setTimeout(async () => {
          await this.getInfo();
        }, 1000);
        return false;
      }

      // 链接已经被调起
      if (res.status == 3 && this.show != false) {
        Dialog.confirm({
          title: 'prompt',
          message: 'Have you completed the payment?',
          confirmButtonText: 'Not paid yet', //取消按钮
          cancelButtonText: 'Paid', //确定按钮
        })
          .then(() => {})
          .catch(() => {
            this.show = false
            this.status = 'prompt'
          })
      }

      // 异常处理
      if (!res.orderAmount) {
        this.show = false
        this.status = 'err'
        this.msg = res.message
        return
      }

      this.form = res

      this.calculateTimeDifference(res.expireTime)
    },

    onFinish() {
      this.show = false
      this.status = 'timeout'
      clearInterval(this.intervalStatus)
    },

    calculateTimeDifference(params) {
      // 获取当前印度时间的 Date 对象
      const currentTime = (() => {
        const indianTimeString = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Kolkata',
        })
        return new Date(indianTimeString)
      })()

      // 订单有效时间
      const expireTime = new Date(params.replace(' ', 'T'))

      // 计算时间差，单位为毫秒
      const timeDifference = expireTime - currentTime

      // 将结果赋值给 time
      this.time = timeDifference
    },

    copyUpiId() {
      h5CheckOutClickV2(
        { platOrderId: this.$route.query.orderId, payMethod: 1 },
        this.headers
      )
        .then((res) => {
          try {
            console.log('res', res)
            this.copyToClipboard(this.form.upiAccount)
            this.$toast.success('Replicating Success')
          } catch (err) {
            this.$toast.fail('Copy failed, please try again!')
            console.error('复制失败：', err)
          }
        })
        .catch((err) => {
          this.show = false
          Toast.fail('This order has expired')
        })
    },
    copyToClipboard(text) {
      // 退回到传统的复制方法
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.select()
      try {
        document.execCommand('copy')
        console.log('复制成功')
      } catch (err) {
        console.error('复制失败:', err)
      } finally {
        document.body.removeChild(textArea)
      }
    },

    submitPayment() {
      if (!this.utrValue) {
        Toast.fail('Please enter the UTR.')
        return
      }
      h5CheckOutUtrSubmit(
        {
          platOrderId: this.$route.query.orderId,
          utr: this.utrValue,
        },
        this.headers
      )
        .then((res) => {
          this.show = false
          this.status = 'wait'
          this.startCountdown()
        })
        .catch((err) => {
          Toast.fail(err.message)
        })
    },

    payOne(num, url) {
      if (num == 9) {
        window.open(this.url, '_blank')
        return
      }

      if (url) {
        this.url = url
      }
      if (num == 3) {
        this.showNum = 1
        this.showOne = true
      } else {
        if (num == 1) {
          this.showNum = 2
          this.showOne = true
        } else {
          if (num == 2) {
            this.showNum = 9
            this.showOne = true
          }
        }
        h5CheckOutClickV2(
          {
            platOrderId: this.$route.query.orderId,
            payMethod: num == 1 ? 2 : num == 2 ? 3 : 1,
          },
          this.headers
        ).then((res) => {
          // if (res.status == 200) {
          // if (num == 1) {
          //   this.showNum = 2
          //   this.showOne = true
          // } else {
          //   if (num == 2) {
          //     this.showNum = 9
          //     this.showOne = true
          //   }
          // }
          // }
        })
      }
    },

    setRootFontSize() {
      const baseSize = 16 // 基准字体大小
      const scale = document.documentElement.clientWidth / 375 // 375 为设计稿宽度
      document.documentElement.style.fontSize =
        baseSize * Math.min(scale, 2) + 'px' // 限制缩放倍数
    },
  },
  computed: {
    formattedQrCode() {
      // 动态拼接前缀
      return `data:image/png;base64,${this.form.qrCode}`
    },
  },
  created() {
    this.getInfo()
    this.intervalStatus = setInterval(() => {
      this.getStatus()
      if (this.countdown <= 0) {
        clearInterval(this.intervalStatus)
      }
    }, 3000)
  },
  mounted() {
    this.setRootFontSize()
    window.addEventListener('resize', this.setRootFontSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setRootFontSize)
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.payment-page {
  min-height: 100vh;
  padding: 1rem;
}

.topT {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.topT > div:nth-child(1) {
  font-size: 18px;
  align-items: center;
  color: #212739;
}

.moneyBox {
  width: 100%;
  background: #f2f2f2;
}

.moneyBox p {
  font-size: 24pt;
  color: #212739;
  margin-left: 15pt;
  line-height: 54px;
}

.payBox {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  font-size: 14px;
  border-bottom: 1px solid #f2f2f2;
}

.payBox div {
  display: flex;
  align-items: center;
}

.img1 {
  width: 20px;
  height: 20px;
  margin-right: 11px;
}
.img2 {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  margin-right: 2px;
}

.payBtn {
  width: 69px;
  height: 26px;
  font-size: 12px;
  background: #2088eb;
  border-radius: 13px;
  color: #fff;
  text-align: center;
  line-height: 26px;
  justify-content: space-around;
  cursor: pointer;
}

.txtBox1 {
  margin-top: 24pt;
  padding: 23pt 12pt 20pt;
  font-size: 14px;
  border: 1px solid #c5c3c3;
  border-radius: 8pt;
  line-height: 26px;
  color: #fc4877;
}

.txtBox2 {
  margin-top: 14pt;
  padding: 23pt 12pt 20pt;
  font-size: 14px;
  border: 1px solid #c5c3c3;
  border-radius: 8pt;
  line-height: 26px;
}

.content {
  padding: 2rem 16px 60px;
}

.showOneTitle {
  color: #2088eb;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.showOneSearch {
  display: flex;
  margin-bottom: 1rem;
}

.showOneCopy {
  width: 4rem;
  background: #2088eb;
  text-align: center;
  line-height: 2.3rem;
  color: #fff;
  font-size: 1rem;
}

.showOneTxt {
  font-size: 1rem;
  color: #ff6000;
  margin-bottom: 1.3rem;
  line-height: 1.4rem;
}

.showOneSearchLabel {
  display: flex;
}

.showOneSearchLabel p:nth-child(1) {
  color: #ff0000;
  margin-top: 6.5px;
  margin-left: 6.5px;
}
.showOneSearchLabel p:nth-child(2) {
  font-size: 1rem;
  margin-left: 4px;
}

.btnFun {
  width: calc(100% - 80px);
  background: #2088eb;
  margin: 0 auto;
  height: 2.8rem;
  line-height: 2.8rem;
  color: #fff;
  font-size: 1rem;
  text-align: center;
  border-radius: 1.4rem;
}

.qrCodeImgs {
  text-align: center;
  padding-top: 10px;
}

.qrCodeImgs p {
  font-size: 1rem;
  margin-bottom: 14px;
}

.sBox {
  height: 95vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sp {
  margin-top: 20px;
  font-family: Source Sans Variable;
  font-weight: 600;
  font-size: 15px;
  color: #333333;
}
.circle {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dots {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: rotate 2.4s infinite linear;
}

.dot {
  width: 12px;
  height: 12px;
  background-color: #ddd;
  border-radius: 50%;
  position: absolute;
}

.countdown {
  position: absolute;
  font-size: 24px;
  color: red;
  font-weight: bold;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dot-animation {
  0% {
    opacity: 0.3;
    transform: scale(0.7);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.7);
  }
}

.mSy {
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
}

.mSyTwo {
  font-size: 16px;
  display: block;
  text-align: center;
}

.payTxt {
  background: #f4f9fe;
  color: #5593f3;
  padding: 14px 20px;
  width: 100%;
  margin-bottom: 28px;
}

.dBox {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  padding: 20pt;
  width: 100vw; /* 固定宽度 */
  height: 100vh; /* 固定高度 */
  overflow: auto; /* 自动显示滚动条 */
  z-index: 99999999999999999999999999999;
}

.dBox img {
  width: 100%;
}

.nos {
  position: fixed;
  top: 0;
  right: 0;
  width: 36pt;
  height: 36pt;
  border-radius: 18pt;
  text-align: center;
  line-height: 40pt;
  background: #fff;
  font-size: 22px;
}

.dBox p {
  margin: 20px 0;
  font-size: 22px;
}

.test1 {
  color: red;
  margin-bottom: 12px;
  text-align: right;
  text-decoration: underline;
}
</style>
